const ERROR_MESSAGE_PREFIX = 'Undefined middleware name ';

export default class UndefinedMiddlewareModuleName extends Error {
  constructor(moduleName: string) {
    super(`${ERROR_MESSAGE_PREFIX}${moduleName}`);
  }
}
